import React, { useEffect, useRef } from "react";
import { useNavigate } from "react-router-dom";

const ImageBox = ({
  boxType,
  imagePath,
  boxTitle,
  boxLoaded,
  onImageLoad,
  onClickPath,
}) => {
  const boxRef = useRef(null);
  const navigate = useNavigate();

  useEffect(() => {
    const img = new Image();
    img.src = imagePath;

    img.onload = () => {
      console.log("AAA");
      onImageLoad();
    };
  }, []);

  return (
    <div
      onClick={() => {
        navigate(onClickPath);
      }}
      ref={boxRef}
      className={boxType}
    >
      <div className="boxTitle">
        <b>{boxTitle}</b>
      </div>
      <div
        className={`imageBox ${boxLoaded ? "loaded" : ""}`}
        style={{ backgroundImage: `url('${imagePath}')` }}
      ></div>
    </div>
  );
};

export default ImageBox;
